module.exports = __webpack_public_path__ + "static/media/msg_tip.0bf76389.mp3";